import React from 'react';
import '../style.css';

const Workflow = () => {
  return (
    <div className="data-analysis-steps" id="Workflow">
      <h2 className="section-heading-center">Our Workflow</h2>
      <h2 className="section-subtitle-center">The process behind the insight</h2>
      <div className="steps-container">
        <div className="single-item">
          <div className="item">
            <div className="info icon">
              <h4><strong>Define the Problem</strong></h4>
              <i className="flaticon-research icon" style={{ color: '#3366cc' }}></i>
              <p><strong>Identify</strong> the problem for setting clear, focused objectives.</p>
            </div>
          </div>
        </div>
        <img src="/assets/img/direction-sign.png" alt="Arrow" className="arrow" aria-hidden="true" />
        <div className="single-item">
          <div className="item">
            <div className="info icon">
              <h4><strong>Prepare</strong></h4>
              <i className="flaticon-data-collection icon" style={{ color: '#3366cc' }}></i>
              <p><strong>Gather</strong> and <strong>clean</strong> data for a reliable foundation for analysis.</p>
            </div>
          </div>
        </div>
        <img src="/assets/img/direction-sign.png" alt="Arrow" className="arrow" aria-hidden="true" />
        <div className="single-item">
          <div className="item">
            <div className="info icon">
              <h4><strong>Analyse</strong></h4>
              <i className="flaticon-cloud-data icon" style={{ color: '#3366cc' }}></i>
              <p><strong>Examine</strong> the data for uncovering meaningful patterns and insights.</p>
            </div>
          </div>
        </div>
        <img src="/assets/img/direction-sign.png" alt="Arrow" className="arrow" aria-hidden="true" />
        <div className="single-item">
          <div className="item">
            <div className="info icon">
              <h4><strong>Act</strong></h4>
              <i className="flaticon-monitor icon" style={{ color: '#3366cc' }}></i>
              <p><strong>Present</strong> results for informed decisions and actionable outcomes.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Workflow;